import Excel from "exceljs";
import moment from "moment";

export default function extractDirectSalesData(
  file,
  productData,
  userData,
  selectedDate,
) {
  return new Promise(async (resolve, reject) => {
    const wb = new Excel.Workbook();
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    let salesDatas = [];
    const startDate = moment(selectedDate)
      .startOf("month")
      .format("YYYY-MM-DD");
    const endDate = moment(selectedDate).endOf("month").format("YYYY-MM-DD");

    reader.onload = () => {
      const buffer = reader.result;
      try {
        wb.xlsx.load(buffer).then(async (workbook) => {
          const salesDataWorkSheet = workbook.getWorksheet(1);
          salesDataWorkSheet.eachRow((row, rowIndex) => {
            if (rowIndex >= 2 && row.values[1]) {
              if (
                !moment(row.values[4]).isBetween(
                  startDate,
                  endDate,
                  "day",
                  "[]",
                )
              ) {
                reject({ message: "dateIsNotCorrect" });
                return false;
              }
              salesDatas.push({
                order_id: row.values[1].replace(/\s/g, ""),
                tx_date: moment(row.values[4]).format("YYYY-MM-DD"),
                user_id: userData[row.values[2].replace(/\s/g, "")].id,
                alias: userData[row.values[2].replace(/\s/g, "")].alias,
                staff_code:
                  userData[row.values[2].replace(/\s/g, "")].staff_code,
                product_id: productData[`${row.values[8]}-1`],
                qty: row.values[10],
                amount: row.values[11],
                calculation_method:
                  row.values[12] === "%"
                    ? "commission_scheme"
                    : "product_commission",
                calculation_value:
                  row.values[12] === "%" ? null : row.values[12],
              });
            }
          });
          resolve(salesDatas);
        });
      } catch (err) {
        console.log(err);

        throw err;
      }
    };
  });
}
